import { gql } from '@apollo/client';

export const ValidateEmailChangeRequest = gql`
  mutation ValidateEmailChangeRequest($token: String!) {
    validateEmailChangeRequest(token: $token) {
      newEmail
    }
  }
`;
